// Prezzi mostrati (IVA inclusa). Gli identificativi Stripe restano nel backend.
// Il prezzo al giorno è sempre derivato dall'importo: mai scritto a mano.
export const PERIOD_DAYS = { monthly: 30, quarterly: 90, annual: 365 };
const PERIOD_UNIT = { monthly: 'mese', quarterly: 'trimestre', annual: 'anno' };
const BILLED_ADVERB = { monthly: 'mensilmente', quarterly: 'trimestralmente', annual: 'annualmente' };

export const BILLING_OPTIONS = [
  { id: 'monthly', label: 'Mensile' },
  { id: 'quarterly', label: 'Trimestrale' },
  { id: 'annual', label: 'Annuale' }
];

const f = (text, included = true) => ({ text, included });

export const PLANS = [
  {
    id: 'fondatori',
    name: 'Founder Club',
    subtitle: 'Prezzo bloccato per sempre',
    prices: { monthly: 6.9, annual: 69.9 },
    theme: 'founder',
    features: [
      f('Monitoraggio completo'), f('1 destinatario'), f('Report settimanale PDF'), f('Supporto prioritario'),
      f('Tasto Scudo Emergenza'), f('Prezzo bloccato per sempre'),
      f('Team e Calendario', false), f('GPS passeggiate', false), f('Stazione Digitale inclusa', false)
    ],
    cta: 'Scegli Founder Club'
  },
  {
    id: 'standard',
    name: 'Standard',
    subtitle: 'Per tutta la famiglia',
    prices: { monthly: 15, quarterly: 38.9, annual: 120 },
    theme: 'standard',
    badge: 'PIÙ SCELTO',
    features: [
      f('Monitoraggio completo'), f('1 destinatario'), f('Report settimanale PDF'), f('Supporto prioritario'),
      f('Tasto Scudo Emergenza'),
      f('Team e Calendario', false), f('GPS passeggiate', false), f('Stazione Digitale inclusa', false)
    ],
    cta: 'Scegli Standard'
  },
  {
    id: 'premium',
    name: 'Premium',
    subtitle: 'La protezione e il controllo più avanzati',
    prices: { monthly: 21, quarterly: 54, annual: 169.9 },
    theme: 'premium',
    features: [
      f('Monitoraggio completo'), f('2 destinatari'), f('Report settimanale e mensile PDF'), f('Supporto prioritario'),
      f('Tasto Scudo Emergenza'), f('Team e Calendario'), f('GPS passeggiate'), f('Stazione Digitale inclusa')
    ],
    cta: 'Scegli Premium'
  }
];

export const formatEuro = (amount) => {
  const rounded = Math.round(amount * 100) / 100;
  return `€${Number.isInteger(rounded) ? rounded : rounded.toFixed(2).replace('.', ',')}`;
};

export const perDayPrice = (amount, period) => `€${(Math.round((amount / PERIOD_DAYS[period]) * 100) / 100).toFixed(2).replace('.', ',')}`;

export const billedText = (amount, period) => `Fatturato ${BILLED_ADVERB[period]} a ${formatEuro(amount)}/${PERIOD_UNIT[period]}`;

export const annualSaving = (plan) => {
  const saving = plan.prices.monthly * 12 - plan.prices.annual;
  return saving > 0 ? Math.round(saving * 100) / 100 : 0;
};

// Mesi gratis con l'annuale = risparmio / prezzo mensile, una cifra decimale con la virgola ("4", "3,9")
export const annualFreeMonths = (plan) => {
  const months = Math.round((annualSaving(plan) / plan.prices.monthly) * 10) / 10;
  return Number.isInteger(months) ? `${months}` : months.toFixed(1).replace('.', ',');
};

// Piani acquistabili ora: Founder Club escluso quando esaurito (stesso segnale delle card: useFounderSpots().soldOut)
export const purchasablePlans = (founderSoldOut) => PLANS.filter((p) => !(p.id === 'fondatori' && founderSoldOut));

export const entryMonthlyPrice = (founderSoldOut = false) =>
  formatEuro(Math.min(...purchasablePlans(founderSoldOut).map((p) => p.prices.monthly)));

export const purchasablePlanNames = (founderSoldOut = false) => {
  const names = purchasablePlans(founderSoldOut).map((p) => p.name);
  return names.length > 1 ? `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}` : names[0];
};

export const plansForPeriod = (period) => PLANS.filter((plan) => plan.prices[period] != null);

export const planPriceLabel = (planId, period) => {
  const plan = PLANS.find((p) => p.id === planId);
  const amount = plan?.prices[period];
  return amount == null ? null : `${formatEuro(amount)}/${PERIOD_UNIT[period]}`;
};
